<script setup>
import { watch } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import {
  accessProfileNotice,
  clearAccessProfileNotice,
  setAccessProfileContext,
} from 'dashboard/helper/accessProfileNotice';

const user = useMapGetter('getCurrentUser');
const accountId = useMapGetter('getCurrentAccountId');
const closeNoticeLabel = 'Fechar aviso';
watch([user, accountId], ([value, id]) => setAccessProfileContext(value, id), {
  immediate: true,
});
</script>

<template>
  <div
    v-if="accessProfileNotice"
    role="status"
    aria-live="polite"
    class="flex shrink-0 items-start gap-3 border-b border-n-weak bg-n-solid-2 px-4 py-3 text-sm text-n-slate-12"
  >
    <span class="i-lucide-info mt-0.5 size-4 shrink-0" aria-hidden="true" />
    <p class="m-0 flex-1 leading-6">{{ accessProfileNotice.message }}</p>
    <button
      type="button"
      class="shrink-0 rounded p-1 text-n-slate-11 hover:bg-n-alpha-2"
      :aria-label="closeNoticeLabel"
      @click="clearAccessProfileNotice"
    >
      <span class="i-lucide-x block size-4" aria-hidden="true" />
    </button>
  </div>
</template>
